import styles from "../components/PlannerEventUserItem.module.scss";
import { UserEventStatus } from "../../../../common/enums";

interface StatusTag {
  label: string;
  color: string;
}

interface StatusDefinition {
  class: string;
  label: string;
  color: string;
  additionalTag?: StatusTag;
}

const statusMap: Record<string, StatusDefinition> = {
  pending: {
    class: styles.item_pending,
    label: "Очаква потвърждение",
    color: "#f391fa",
  },
  confirmed: {
    class: styles.item_confirmed,
    label: "Потвърдена",
    color: "#9cd0f9",
  },
  cancelled: {
    class: styles.item_cancelled,
    label: "Отказана",
    color: "#f5a6ad",
  },
  arrived: {
    class: styles.item_arrived,
    label: "Взета",
    color: "#a4f1ac",
  },
  waiting: {
    class: styles.item_waiting,
    label: "В изчакващи",
    color: "#94ffe6",
  },
  missed: {
    class: styles.item_missed,
    label: "Пропусната",
    color: "#f8cea3",
  },
  paidOnly: {
    class: styles.item_paidOnly,
    label: "Платена без присъствие",
    color: "#e6f651",
  },
  penaltyCancelled: {
    class: styles.item_cancelled,
    label: "Отказана",
    color: "#f5a6ad",
  },
  unconfirmed: {
    class: styles.item_pending,
    label: "Непотвърдена",
    color: "#fbc6fe",
  },
  default: {
    class: "",
    label: "",
    color: "",
  },
};

export const getStatus = (
  isEventPassed: boolean,
  status?: UserEventStatus,
  isCancelled?: boolean,
  pricePaid?: number | null,
): StatusDefinition => {
  if (!status) {
    return statusMap.default;
  }

  // Check if cancelled/deleted first - takes precedence over status
  if (isCancelled) {
    return statusMap.cancelled;
  }

  if (status === UserEventStatus.PenaltyCancelled) {
    const baseStatus = { ...statusMap.penaltyCancelled };

    if (!pricePaid) {
      baseStatus.additionalTag = {
        label: "Очаква плащане",
        color: "#ffc107",
      };
    }

    return baseStatus;
  }

  // Show "Missed" for Confirmed reservations when event has passed
  if (isEventPassed && status === UserEventStatus.Confirmed) {
    return statusMap.missed;
  }

  // Show "Unconfirmed" for Pending reservations when event has passed
  if (isEventPassed && status === UserEventStatus.Pending) {
    return statusMap.unconfirmed;
  }

  switch (status) {
    case UserEventStatus.Pending:
      return statusMap.pending;
    case UserEventStatus.Confirmed:
      return statusMap.confirmed;
    case UserEventStatus.Arrived:
      return statusMap.arrived;
    case UserEventStatus.WaitingList:
      return statusMap.waiting;
    case UserEventStatus.Missed:
      return statusMap.missed;
    case UserEventStatus.OnlyPaid:
      return statusMap.paidOnly;

    default:
      return isEventPassed ? statusMap.missed : statusMap.default;
  }
};
